import React from 'react';
import {useSelector} from 'react-redux';
import './Dashboard.scss';
import {ERoleId} from '../../const/dataEnum';
import {selectPeriodeAndAuthRole} from '../../stores/selectors/appStateSelector';
import EmployeeDashbord from './EmployeeDashbord';
import ManagerDashbord from './ManagerDashbord';
import AdminDashbord from './AdminDashbord';

export default function Dashboard() {
  const {periode, currentPeriodId, userAuthRoleId} = useSelector(selectPeriodeAndAuthRole);

  const dashboardContent = () => {
    switch (userAuthRoleId) {
      case ERoleId.MANAGER:
        return <ManagerDashbord periode={periode}/>;
      case ERoleId.TEAM_LEADER:
        return <ManagerDashbord periode={periode}/>;
      case ERoleId.PRACTICE_LEADER:
        return <ManagerDashbord periode={periode}/>
      case ERoleId.PMD:
        return <ManagerDashbord periode={periode}/>
      case ERoleId.PM:
        return <ManagerDashbord periode={periode}/>
      case ERoleId.ADMINISTRATOR:
        return <AdminDashbord periode={periode} currentPeriod={currentPeriodId} />;
      default:
        return <EmployeeDashbord periode={periode} currentPeriod={currentPeriodId} />;
    }
  };

  return <div className="dashboard">{periode && dashboardContent()}</div>;
}
